export default __webpack_public_path__ + "static/media/KN Jewellery.772cb354.png";